// mission-initializer-registration.ts
//
// Tách THUẦN từ mission-initializer.ts (phase 10, lô A): 3 bước ghi đăng ký sau
// khi mission workspace đã tạo (bước 7/8/8b gốc) — pending G0/G1 gates,
// compatibility manifest, baseline tuple pin. Gộp vào 1 hàm orchestration để
// `initMission` gọi 1 lần — không đổi thứ tự/side effect.

import { requestGate } from "./gate-registry.js";
import { writeCompatibilityManifest } from "./mission-initializer-compatibility.js";
import { writeInitialPinBaseline } from "./mission-initializer-pin-baseline.js";
import type { InitRequest } from "./schemas/init-schema.js";

export interface RegisterInitializedMissionInput {
  controlRoot: string;
  missionWorkspace: string;
  operationId: string;
  request: InitRequest;
  cliVersion: string;
  settingsProfileSha256: string;
  permissionsAllowFallback: boolean;
  now: () => Date;
  probeClaudeVersion?: () => Promise<{ path: string; version: string; hash: string }>;
  probePinClaudeVersion?: () => Promise<string>;
}

/**
 * 7. Pending G0/G1 gates. G0 carries the blueprint hash, lowercased once
 * here so the dispatch recheck compares like with like.
 *
 * 8. Compatibility manifest (settings/profile digest from P3's combined digest).
 *
 * 8b. R-24: baseline tuple pin — đọc settings_digest từ compatibility.json nên
 * phải chạy sau bước 8.
 */
export async function registerInitializedMission(
  input: RegisterInitializedMissionInput,
): Promise<void> {
  const { controlRoot, missionWorkspace, operationId, request, now } = input;

  await requestGate(
    controlRoot,
    "g0",
    `G0-${operationId.slice(5, 13)}`,
    request.blueprint.bytes_sha256.toLowerCase(),
    now,
  );
  await requestGate(controlRoot, "g1", `G1-${operationId.slice(5, 13)}`, undefined, now);

  await writeCompatibilityManifest({
    missionWorkspace,
    controlRoot,
    cliVersion: input.cliVersion,
    settingsProfileSha256: input.settingsProfileSha256,
    permissionsAllowFallback: input.permissionsAllowFallback,
    now,
    probeClaudeVersion: input.probeClaudeVersion,
  });

  await writeInitialPinBaseline({
    missionWorkspace,
    controlRoot,
    now,
    probeClaudeVersion: input.probePinClaudeVersion,
  });
}
